import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class JurisdictionAdministrativeDivisionDescriptor extends Enum {
  static PROVINCE = {
    key: 'province',
    get value() {
      return Lang.t('predefined.province');
    }
  };

  static STATE = {
    key: 'state',
    get value() {
      return Lang.t('predefined.state');
    }
  };

  static TERRITORY = {
    key: 'territory',
    get value() {
      return Lang.t('predefined.territory');
    }
  };

  static REGION = {
    key: 'region',
    get value() {
      return Lang.t('predefined.region');
    }
  };

  static CANTON = {
    key: 'canton',
    get value() {
      return Lang.t('predefined.canton');
    }
  };

  static DISTRICT = {
    key: 'district',
    get value() {
      return Lang.t('predefined.district');
    }
  };

  static OBLAST = {
    key: 'oblast',
    get value() {
      return Lang.t('predefined.oblast');
    }
  };
}
